import {
  Box,
  Center,
  SimpleGrid,
} from "@chakra-ui/react";
import CardPhilosophy from "./cardPhylosophy";
import SectionHeading from "./sectionHeading";

export default function Philosophy() {
  return (
    <Box>

      <Box
        color='white'
      >

        <SectionHeading
          title="Philosophy"
          subtitle="behind our social initiatives" 
          />

        <Center>
          <SimpleGrid
            columns={{ base: 1, md: 3, lg: 3, xl: 3 }}
            spacing={10}
            pb={{base: 10, md: 20}}
            >
            <CardPhilosophy
              image="img/crowd-laughing-children-is-heartwarming-sight-that-represents-pure-joy-carefree-spirit-childhood-generative-ai.webp"
              title="Mission"
              texts="Generate positive and lasting impact in the lives of young people in vulnerable conditions, from countries with low-incomes, providing them with equal opportunities to achieve their goals of educating themselves in programming languages and technology skills."
              id={1}
              />
            <CardPhilosophy
              image="img/night-portrait-black-woman-with-arms-crossed-work-business-pride-deadline-desk-happy-african-employee-with-confidence-during-overtime-late-shift-office.webp"
              title="Commitment"
              texts="We believe in a world where human potential is not limited by economic circumstances and where every young person has the possibility of becoming an agent of change in the global technology industry."
              id={2}
            />
            <CardPhilosophy
              image="img/young-asian-teen-plugging-energy-signal-cable-sensor-chip-toy-car-workshop.webp"
              title="Social objective"
              texts="Foster creativity and passion for learning programming languages in low-income youth, in order to promote their professional growth for the benefit of the social group where they live."
              id={3}
              />
          </SimpleGrid>
        </Center>
      </Box>
    </Box>
  );
}
